import { useTheme } from '../../contexts/ThemeContext';

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 dark:bg-slate-800 dark:hover:bg-slate-700 transition-colors duration-200 group"
    >
      {theme === 'light' ? (
        // Moon icon - elegant crescent
        <svg
          className="w-5 h-5 text-gray-700 dark:text-slate-300 transition-colors duration-300 group-hover:text-gray-900 dark:group-hover:text-slate-100"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z" />
        </svg>
      ) : (
        // Sun icon - elegant rays
        <svg
          className="w-5 h-5 text-amber-600 dark:text-amber-400 transition-colors duration-300 group-hover:text-amber-700 dark:group-hover:text-amber-300"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12a9 9 0 11-18 0 9 9 0 0118 0m-10.5 3.75a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 12a3 3 0 11-6 0 3 3 0 016 0zm6-1.5v.75m0 4.5v.75M3.75 13.5h.75m4.5 0h.75M3 12a9 9 0 1118 0 9 9 0 01-18 0z" />
        </svg>
      )}
    </button>
  );
};
